<template>
  <v-container>
    <v-card>
      <v-card-title>Detalhes da Solicitação</v-card-title>
      <v-card-text>
        <div v-if="loading" class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p>Buscando detalhes...</p>
        </div>
        <div v-else-if="error" class="text-center">
          <p class="text-error">Ocorreu um erro ao buscar os detalhes da solicitação.</p>
        </div>
        <div v-else v-html="formattedDetails"></div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$router.back()">Voltar</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';

const route = useRoute();
const loading = ref(true);
const error = ref(false);
const details = ref('');

const formattedDetails = computed(() => {
  if (!details.value) return '';
  const dateRegex = /\d{2}\/\d{2}\/\d{4}/;
  return details.value
    .split('\n')
    .filter(line => !dateRegex.test(line))
    .join('\n')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
    .replace(/\n/g, '<br>'); // Newlines
});

const fetchDetails = async (protocolo) => {
  if (!protocolo) return;

  loading.value = true;
  error.value = false;
  details.value = '';

  try {
    const response = await axios.post('https://n8n.app-hom.cassems.com.br/webhook/protocolos-reembolso', { protocolo });
    details.value = response.data.output;
  } catch (err) {
    console.error('Erro ao buscar detalhes da solicitação:', err);
    error.value = true;
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchDetails(route.params.protocolo);
});

watch(
  () => route.params.protocolo,
  (newProtocolo) => {
    fetchDetails(newProtocolo);
  }
);
</script>
